/**
 * @generated SignedSource<<0eed857a56f6014874ba0380eca7986b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type mondayStreamDetails$data = {
  readonly assigneeColumnId: string | null;
  readonly dueDateColumnId: string | null;
  readonly externalBoardId: string;
  readonly externalBoardName: string;
  readonly externalGroupId: string;
  readonly externalGroupName: string;
  readonly includeAiGenerated: boolean;
  readonly mondayUser: {
    readonly user: {
      readonly fullName: string;
    };
  };
  readonly statusColumnId: string | null;
  readonly " $fragmentType": "mondayStreamDetails";
};
export type mondayStreamDetails$key = {
  readonly " $data"?: mondayStreamDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"mondayStreamDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mondayStreamDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MondayUserNode",
      "kind": "LinkedField",
      "name": "mondayUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalGroupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalBoardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalGroupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalBoardName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigneeColumnId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusColumnId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDateColumnId",
      "storageKey": null
    }
  ],
  "type": "MondayStreamIntegrationNode",
  "abstractKey": null
};

(node as any).hash = "c5f6bb082f3f349c0ba71556344c0154";

export default node;
